import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'
import { customizeVerticalScrollbarThumbMixin } from 'styles/mixins'
import { Icon } from 'common-components'

export const DropdownListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  max-height: 320px;
  overflow-y: auto;
  ${customizeVerticalScrollbarThumbMixin()}
`

export const ModelItemWrapper = styled.div<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;
  padding: 10px 8px;
  border-radius: ${RADII.item};
  border: 1px solid
    ${({ $isSelected }) => ($isSelected ? COLORS.borderColor : 'transparent')};
  cursor: pointer;
  transition: background-color 0.2s;
  background-color: ${({ $isSelected }) =>
    $isSelected ? COLORS.primaryLight : 'transparent'};

  &:hover {
    background-color: ${COLORS.primaryLight};
  }
`

export const CrownBadgeIcon = styled(Icon)`
  display: inline-flex;
  margin-top: -1px;
`

export const ModelTextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`

export const ModelNameWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
`

export const CreditsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 6px;
`

export const ModelVolumeIconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`

export const VolumeIconBox = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${COLORS.secondary};

  & > svg {
    fill: ${COLORS.secondarySemiDark};
  }

  &:hover {
    background: ${COLORS.primaryLight};

    & > svg {
      fill: ${COLORS.secondaryDark};
    }
  }
`

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const BetaBadge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  border-radius: 4px;
  background-color: ${COLORS.primaryDark};
`
